import { render, staticRenderFns } from "./BuildingRegistrationComponent.vue?vue&type=template&id=cc5d6dec&scoped=true&"
import script from "./BuildingRegistrationComponent.vue?vue&type=script&lang=js&"
export * from "./BuildingRegistrationComponent.vue?vue&type=script&lang=js&"
import style0 from "./BuildingRegistrationComponent.vue?vue&type=style&index=0&id=cc5d6dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5d6dec",
  null
  
)

export default component.exports